import React, {useEffect} from 'react'
import ClientSuspense from '@components/ClientSuspense'
import {EVENTS} from '@helpers/analytics/events'
import {PurchaseTaxonomies} from '@helpers/analytics/events/purchase'
import {sendEvent} from '@helpers/analytics/sendEvents'
import useEventsBaseProperties from '@hooks/useEventsBaseProperties'

import usePreferences from './hooks/usePreferences.main'

const sendEventTracker = (preferences, baseProperties) => {
  sendEvent<PurchaseTaxonomies['checkoutPageViewed']>(EVENTS.purchase.checkoutPageViewed, {
    cartItemsAmount: preferences?.cart?.items.reduce((sum, item) => item.amount + sum, 0),
    productAmount: preferences?.cart?.items?.length,
    subTotalPrice: preferences?.cart?.itemsPrice,
    isTipAccepted: preferences?.cart?.acceptsTip,
    deliveryAmountToPay: preferences?.cart?.deliveryFee,
    amountToPay: preferences?.cart?.totalPrice,
    isScheduledOrder: preferences?.time && preferences?.time !== 'now',
    timeLabel: preferences?.timeLabel,
    minDeliveryTime: '',
    maxDeliveryTime: '',
    currentPreparationDuration: preferences?.store?.currentPreparationDuration,
    currentDeliveryDuration: preferences?.store?.currentDeliveryDuration,
    availablePaymentTypes: preferences?.store?.availablePaymentTypes,
    ...baseProperties
  })
}

function TrackPageViewInner() {
  const {preferences} = usePreferences()
  const baseEventsProperties = useEventsBaseProperties()
  useEffect(() => {
    if (!preferences?._id) return

    sendEventTracker(preferences, baseEventsProperties)
  }, [preferences?._id])

  return null
}

export default function TrackPageView() {
  return (
    <ClientSuspense fallback={null}>
      <TrackPageViewInner />
    </ClientSuspense>
  )
}
